<template>
  <div>
    In order to submit your application, you need to fill out all the required
    fields at the sections of this page. By the end of the process, you will be
    able to preview your application that will be similar to the following
    image:
    <b-img
      src="./static/preview/application_first_page.jpg"
      title="Application First Page"
      alt="First page of the application."
      fluid
    >
    </b-img>
    <vue-form-generator
      :schema="schema.schema"
      :model="model"
      ref="informationForm"
    />
    <wizard-verified-submit-button
      text="I agree to provide the information"
      nextText="I agree to provide the information"
      @submit="agreeToTerms"
    />
  </div>
</template>

<script>
import WizardVerifiedSubmitButton from '@/components/utils/buttons/form/WizardVerifiedSubmitButton';
import { DEFINE_PROFILE_AGREEMENT } from '@/vuex/modules/profile/types/actions';
import helper from '@/libs/helper';
import SCHEMA from '@/components/profile/sections/tabs/agreement/schema';
import { CONTACT_TAB } from '@/components/profile/sections/tabs/tabNumbers';

export default {
  name: 'InformationContent',
  data() {
    return {
      model: {},
      schema: SCHEMA,
      CONTACT_TAB,
    };
  },
  components: { WizardVerifiedSubmitButton },
  methods: {
    agreeToTerms(moveTab) {
      if (!this.isValid()) {
        window.scrollTo(0, 0);
        return;
      }
      const data = {
        agreed: this.model.agreed,
      };
      this.$reqs
        .post(
          `/users/${this.$store.getters.user.id}/profile/agreement`,
          data,
        )
        .then((response) => {
          this.$store.dispatch(DEFINE_PROFILE_AGREEMENT, {
            agreement: {
              agreed: response.data.agreement,
            },
          });
          this.$emit('tab-info-updated', 'Agreement');
          if (moveTab) {
            this.$emit('move-to-next-tab', CONTACT_TAB);
          }
        })
        .catch(() => {});
    },
    isValid() {
      return this.$refs.informationForm.validate();
    },
    clearValidationErrors() {
      this.$refs.informationForm.clearValidationErrors();
    },
  },
  created() {
    const profile = this.$store.getters.profile;
    if (profile && profile.agreement) {
      this.model = helper.copy(profile.agreement);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/agreement/AgreementContent.vue